/**
 * The title `DashboardHeader` renders for a route.
 *
 * Its own module, not an export from `DashboardScreen`: a file that exports a component may export
 * nothing else, or Fast Refresh stops working for it — `react-refresh/only-export-components`, and
 * it is an ESLint **error** here, so it fails the PR gate.
 *
 * Worth having somewhere testable: it is load-bearing for any section that deliberately renders no
 * <h1> of its own (Trusted Contacts). Lose the entry and the page is silently titled "Players"
 * while that section's own tests stay green.
 */
export const getSectionTitle = (pathname: string): string => {
  if (pathname.includes('/players')) return 'Players';
  if (pathname.includes('/calls')) return 'Call List';
  if (pathname.includes('/video')) return 'Video';
  if (pathname.includes('/latest-notes')) return 'Latest Notes';
  if (pathname.includes('/rosters') || pathname.includes('/scholarships')) return 'Rosters';
  if (pathname.includes('/schedule')) return 'Schedule';
  if (pathname.includes('/trusted-contacts')) return 'Trusted Contacts';
  return 'Players';
};
